var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "13.444201312910284 14.14 37.53172866520788 40.879999999999995",
    style: {
      maxHeight: 500
    },
    width: 37.53172866520788,
    height: 40.879999999999995,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEEEEE",
    d: "M32.1997 54.8949C42.2612 54.8949 50.4177 46.752 50.4177 36.7072C50.4177 26.6624 42.2612 18.5195 32.1997 18.5195C22.1382 18.5195 13.9817 26.6624 13.9817 36.7072C13.9817 46.752 22.1382 54.8949 32.1997 54.8949Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M43.9138 32.3179H35.0809C36.4293 30.2092 37.2853 26.3568 36.6977 23.2853C36.4809 22.1505 35.5803 21.2766 34.4224 21.2756C33.5268 21.2807 32.7822 21.9533 32.6718 22.8413C32.4651 24.4969 31.8077 27.1346 29.744 29.0501C28.6053 30.107 27.3927 31.3601 26.5833 32.1217C25.8893 32.7751 23.9027 34.8342 23.9027 34.8342L23.8014 45.1473V34.7978C23.8014 34.0949 23.23 33.5245 22.5259 33.5245H19.7015C18.9974 33.5245 18.426 34.0949 18.426 34.7978V47.4047C18.426 48.1076 18.9974 48.6781 19.7015 48.6781H22.5259C23.1449 48.6781 23.6606 48.2381 23.7771 47.6535V47.7385L25.5864 47.7304C26.1405 47.7304 26.6825 47.8963 27.1415 48.2057C28.2579 48.9602 29.5759 49.3628 30.9243 49.3628H41.6294C42.6769 49.3628 43.5268 48.5142 43.5268 47.4684C43.5268 46.4227 42.6941 45.5923 41.6618 45.5751H42.6232C43.7406 45.5751 44.6473 44.671 44.6473 43.5544V43.1751C44.6473 42.0596 43.7416 41.1554 42.6242 41.1544H43.2827C44.4001 41.1544 45.3068 40.2502 45.3068 39.1336V38.7544C45.3068 37.8431 44.703 37.0734 43.8733 36.8216L43.9158 36.7346C45.0333 36.7346 45.94 35.8305 45.94 34.7139V34.3346C45.94 33.2191 45.0343 32.3139 43.9158 32.3139L43.9138 32.3179ZM42.6222 41.1574L40.5616 45.5761H39.6123L41.7621 41.1574H42.6211H42.6222Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M42.4811 35.7111C43.5985 35.7111 44.5052 36.6153 44.5052 37.7318V38.1101C44.5052 39.2256 43.5985 40.1308 42.4811 40.1308H41.8216C42.939 40.1308 43.8457 41.035 43.8457 42.1516V42.5298C43.8457 43.6454 42.939 44.5506 41.8216 44.5506H40.8926C41.391 44.5668 41.8398 44.7761 42.1701 45.1038C42.5135 45.4467 42.7263 45.921 42.7263 46.4439C42.7263 47.4897 41.8763 48.3382 40.8288 48.3382H30.1237C29.45 48.3382 28.7824 48.2371 28.1452 48.0419C27.5079 47.8467 26.8991 47.5574 26.3409 47.1802C25.882 46.8697 25.34 46.7038 24.7858 46.7038L22.9765 46.7119L22.9583 46.7068C22.9866 46.6017 23.0018 46.4914 23.0018 46.3771V33.8067H23.1031C23.1031 33.8067 25.0897 31.7475 25.7837 31.0941C26.5931 30.3315 27.8058 29.0784 28.9445 28.0226C31.0071 26.107 31.6656 23.4683 31.8722 21.8127C31.9827 20.9247 32.7273 20.2521 33.6228 20.248C34.2013 20.248 34.7169 20.4665 35.113 20.8276C35.5102 21.1876 35.7888 21.6893 35.8982 22.2577C36.4858 25.3282 35.6307 29.1806 34.2813 31.2903H43.1143C44.2317 31.2903 45.1384 32.1945 45.1384 33.3111V33.6893C45.1384 34.8049 44.2317 35.7101 43.1143 35.7101H42.4821L42.4811 35.7111Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EE5323",
    d: "M23.0021 33.8087V46.3792C23.0021 46.4935 22.9869 46.6037 22.9585 46.7089C22.8137 47.253 22.3162 47.6536 21.7266 47.6536H18.9012C18.1971 47.6536 17.6257 47.0831 17.6257 46.3802V33.7733C17.6257 33.0694 18.1971 32.5 18.9012 32.5H21.7266C22.4307 32.5 23.0021 33.0704 23.0021 33.7733V33.8097V33.8087Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.467329,
    stroke: "#4D4D4D",
    d: "M38.8738 16.3735L37.9985 17.5771"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.467329,
    stroke: "#4D4D4D",
    d: "M42.3709 21.1806L40.9546 21.6408"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.467329,
    stroke: "#4D4D4D",
    d: "M42.3709 27.1223L40.9546 26.6631"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.467329,
    stroke: "#4D4D4D",
    d: "M24.0596 27.1194L25.4769 26.6592"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.467329,
    stroke: "#4D4D4D",
    d: "M24.0596 21.1794L25.4769 21.6386"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.467329,
    stroke: "#4D4D4D",
    d: "M27.5569 16.3735L28.4332 17.5771"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.467329,
    stroke: "#4D4D4D",
    d: "M33.1855 14.5924V16.0013"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.467329,
    stroke: "#4D4D4D",
    d: "M22.9585 46.7078C22.8137 47.252 22.3162 47.6525 21.7266 47.6525H18.9012C18.1971 47.6525 17.6257 47.082 17.6257 46.3791V33.7722C17.6257 33.0683 18.1971 32.4989 18.9012 32.4989H21.7266C22.4307 32.4989 23.0021 33.0693 23.0021 33.7722V46.3791C23.0021 46.4934 22.9869 46.6037 22.9585 46.7088V46.7078Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.467329,
    stroke: "#4D4D4D",
    d: "M22.9766 46.713L24.7859 46.7049C25.3401 46.7049 25.882 46.8708 26.341 47.1813C26.8992 47.5585 27.508 47.8478 28.1452 48.043C28.7825 48.2382 29.4501 48.3393 30.1238 48.3393H40.8289C41.8764 48.3393 42.7263 47.4918 42.7263 46.445C42.7263 45.9221 42.5136 45.4488 42.1702 45.1049C41.8409 44.7762 41.3921 44.5679 40.8927 44.5517C40.8714 44.5517 40.8491 44.5507 40.8278 44.5507H38.8129"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.467329,
    stroke: "#4D4D4D",
    d: "M42.4813 35.7111C43.5987 35.7111 44.5054 36.6152 44.5054 37.7318V38.1101C44.5054 39.2256 43.5987 40.1308 42.4813 40.1308H39.2344"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.467329,
    stroke: "#4D4D4D",
    d: "M41.8228 40.1307C42.9402 40.1307 43.8469 41.0349 43.8469 42.1515V42.5297C43.8469 43.6453 42.9402 44.5505 41.8228 44.5505H39.7622"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.467329,
    stroke: "#4D4D4D",
    d: "M23.1033 33.8087C23.1033 33.8087 25.0899 31.7495 25.7839 31.0961C26.5933 30.3336 27.8059 29.0804 28.9446 28.0246C31.0072 26.109 31.6657 23.4703 31.8724 21.8147C31.9828 20.9267 32.7274 20.2541 33.623 20.2501C34.2014 20.2501 34.7171 20.4685 35.1132 20.8296C35.5103 21.1896 35.7889 21.6913 35.8983 22.2597C36.4859 25.3302 35.6309 29.1826 34.2815 31.2923H43.1144C44.2318 31.2923 45.1385 32.1965 45.1385 33.3131V33.6913C45.1385 34.8069 44.2318 35.7121 43.1144 35.7121H40.0793"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/ThumbsUp.09e20f217b9f4d9370e8047f2898ef9d.svg";
export { ForwardRef as ReactComponent };